module.exports = __webpack_public_path__ + "img/whatsapp-failure.39dc08f7.svg";